'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/20.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WechatPayment = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;

    var state = getState();
    var promises = [];
    if (state.payment.isPublic === '1') {
      promises.push(dispatch((0, _auth.loadPublicUser)()));
    } else {
      promises.push(dispatch((0, _auth.load)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.payment.paymentData,
    isPublic: state.payment.isPublic,
    user: state.auth.user,
    publicUser: state.auth.publicUser,
    error: state.payment.paymentError
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WechatPayment, _Component);

  function WechatPayment() {
    (0, _classCallCheck3.default)(this, WechatPayment);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(WechatPayment).call(this));
  }

  (0, _createClass3.default)(WechatPayment, [{
    key: 'onSuccess',
    value: function onSuccess() {
      var _props = this.props;
      var dispatch = _props.dispatch;
      var data = _props.data;
      var isPublic = _props.isPublic;

      if (dispatch) {
        if (isPublic === '1') {
          dispatch((0, _reactRouterRedux.push)('/publicpayment/' + data.orderNumber));
        } else {
          dispatch((0, _reactRouterRedux.push)('/payment/' + data.orderNumber));
        }
      }
    }
  }, {
    key: 'initSocket',
    value: function initSocket() {
      var _this2 = this;

      var _props2 = this.props;
      var user = _props2.user;
      var publicUser = _props2.publicUser;
      var isPublic = _props2.isPublic;

      var socket = void 0;
      if ('WebSocket' in window) {
        var userId = void 0;
        if (isPublic === '1' && publicUser) {
          userId = publicUser.userId;
        } else if (user) {
          userId = user.userId;
        }
        if (userId) {
          console.log('WebSocket is supported by your browser.');

          var serviceUrl = 'ws://115.182.102.130:1001';
          // const protocol = 'chat';
          socket = new WebSocket(serviceUrl);

          socket.onopen = function () {
            console.log('Connection Established!');
            socket.send('{<' + '49998,e7af3e52-f4c5-4adb-b8e8-27149878857f' + '>}');
          };

          socket.onclose = function () {
            console.log('Connection Closed!');
          };

          socket.onerror = function (error) {
            console.log('Error Occured: ' + error);
          };

          socket.onmessage = function (event) {
            if (typeof event.data === 'string') {
              _this2.handleMessage(event.data);
            } else if (event.data instanceof ArrayBuffer) {
              console.log('ArrayBuffer received: ' + event.data);
            } else if (event.data instanceof Blob) {
              console.log('Blob received: ' + event.data);
            }
          };
        }
      }
      return socket;
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(message) {
      var _props3 = this.props;
      var dispatch = _props3.dispatch;
      var data = _props3.data;
      var isPublic = _props3.isPublic;

      var info = JSON.parse(message);
      if (info.type === 'paymentinfo' && info.orderNumber === data.orderNumber) {
        if (info.success) {
          if (dispatch) {
            if (isPublic === '1') {
              dispatch((0, _reactRouterRedux.push)('/publicpayment/' + data.orderNumber));
            } else {
              dispatch((0, _reactRouterRedux.push)('/payment/' + data.orderNumber));
            }
          }
        } else {
          this.setState({ errorFromSocket: info.error });
        }
      }
    }

    /*
     onFail() {
     console.log('fail');
     }*/

  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var data = _props4.data;
      var error = _props4.error;
      var errorFromSocket = this.state.errorFromSocket;

      var styles = require('./WechatPayment.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: data.qrc }),
        error ? _react2.default.createElement(_components.ErrorLabel, { error: error }) : '',
        errorFromSocket ? _react2.default.createElement(_components.ErrorLabel, { error: errorFromSocket }) : '',
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.btn, onClick: this.onSuccess.bind(this) },
            '支付成功'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.btn, onClick: this.onSuccess.bind(this) },
            '支付遇到问题'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return WechatPayment;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  user: _react.PropTypes.object,
  publicUser: _react.PropTypes.object,
  error: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  isPublic: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = WechatPayment;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WechatPayment/WechatPayment.js
 ** module id = 1551
 ** module chunks = 0
 **/